import React, { useRef } from 'react';
import Modal from '../components/Modal';
import SignInForm from '../components/SignInForm';
import type { SignInFormHandle } from '../components/SignInForm';
import { useAppDispatch } from '../app/hooks';
import { clearPendingRedirect } from '../slices/pendingRedirect';
import { setCurrentModalId } from '../slices/currentModalId';
import { useRedcatAnalytics, trackSigninModalClosed } from '../analytics';

export const SIGN_IN_MODAL_ID = 'SIGN_IN_MODAL_ID';

const SignInModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { track } = useRedcatAnalytics();
  const signInFormRef = useRef<SignInFormHandle>(null);

  const handleClose = () => {
    const snapshot = signInFormRef.current?.getCloseTrackingSnapshot();
    trackSigninModalClosed(track, {
      fieldsCompletedCount: snapshot?.fieldsCompletedCount ?? 0,
      lastFieldFocused: snapshot?.lastFieldFocused ?? null,
    });
    dispatch(clearPendingRedirect());
    dispatch(setCurrentModalId(null));
  };

  return (
    <Modal
      // title={t('title.modal.signIn')}
      desktopMaxWidth={400}
      desktopMinWidth={400}
      desktopContainerStyle={styles.modalDesktopContainer}
      mobileContainerStyle={styles.modalMobileContainer}
      closeButtonLeft
      handleClose={handleClose}
    >
      <SignInForm ref={signInFormRef} />
    </Modal>
  );
};

const styles: Styles = {
  modalDesktopContainer: {
    padding: '70px 70px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
};

export default SignInModal;
